import classNames from 'classnames';
import { Field, useFormikContext } from 'formik';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import { config, getAssetUrl } from '../../utils/config';
import getValidator from '../../utils/getValidator';
import TextField from '../formik/TextField';

type PasswordFieldProps = FieldProps & {
  type: 'signIn' | 'register' | 'passwordReset';
  autocomplete?: 'current-password' | 'new-password';
  isInputStatusIconDisabled?: boolean;
};

const PasswordField = (props: PasswordFieldProps) => {
  const { formatMessage } = useIntl();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { getFieldMeta } = useFormikContext<any>();
  const isTouched = getFieldMeta('password').touched;

  const toggleImage = config.features.passwordVisibilityToggle.enabled && (
    <img
      className={classNames('input__image', { 'input__image--validated': isTouched })}
      src={getAssetUrl(`inputs/${isPasswordVisible ? 'eyeClosed' : 'eye'}.svg`)}
      onClick={() => setIsPasswordVisible(!isPasswordVisible)}
    />
  );

  return (
    <Field
      name={[props.context, 'password'].filter(Boolean).join('.')}
      component={TextField}
      label={formatMessage(
        {
          id:
            props.type === 'passwordReset' ? 'auth.embedded.newPassword'
            : props.type === 'register' ? 'auth.options.register.password'
            : 'generic.password'
        },
        { minLength: config.emailPassword.password.minLength }
      )}
      type={isPasswordVisible ? 'text' : 'password'}
      maxLength={config.emailPassword.password.maxLength}
      validate={
        props.type === 'signIn' ?
          getValidator({ required: true })
        : getValidator({ ...config.emailPassword.password, required: true })
      }
      data-test-id={`${props.testIdPrefix}-password`}
      toggleImage={toggleImage}
      autoComplete={props.autocomplete}
      isInputStatusIconDisabled={props.isInputStatusIconDisabled}
    />
  );
};

export default PasswordField;
